import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-create',
  templateUrl: './site-create.component.html',
  styleUrls: ['./site-create.component.scss']
})
export class SiteCreateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
